<div class="row validable-input-margins margins-check" [formGroup]="formGroup">
  <div class="input-group">
    <div class="input-group-prepend col-12">
         <div class="input-group-text">
          <mat-checkbox color="primary" name="{{customId}}" formControlName="{{customId}}" class="mat-checkbox-component">
            <span class="check-input-text" [innerHTML]="text | translate"></span>

            <app-field-error-display class="check-input-error-container" [displayError]="isFieldNotValid(customId)"
                                     [errorMsg]="getErrorText()">
            </app-field-error-display>
          </mat-checkbox>
         </div>
    </div>
  </div>

</div>
